if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const giftBoxPicker = document.querySelector('gift-box-picker');
        const hasGiftBox = giftBoxPicker && giftBoxPicker.selectedType !== 'none';

        if (hasGiftBox && !giftBoxPicker.isValid) {
          const type = giftBoxPicker.selectedType;
          if (type === 'double') {
            this.handleErrorMessage('Please select both bottles for the Double Gift Box.');
          } else if (type === 'mini') {
            this.handleErrorMessage('Please select exactly 4 bottles for the Mini Gift Box.');
          }
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let fetchPromise;
        const formData = new FormData(this.form);
        const mainVariantId = parseInt(formData.get('id'), 10);

        if (hasGiftBox) {
          const giftBoxData = giftBoxPicker.getGiftBoxItems();
          const groupId = giftBoxData.groupId;
          const type = giftBoxPicker.selectedType;

          let items;
          if (type === 'mini') {
            items = [...giftBoxData.items];
          } else {
            const mainProperties = giftBoxPicker.getMainProductProperties(groupId);
            const primaryVariantId = giftBoxPicker.getMainProductVariantId() || mainVariantId;
            const giftBoxItem = giftBoxData.items[0];
            const companionItems = giftBoxData.items.slice(1);
            // A gift box is a fixed bundle: always 1 primary bottle per box,
            // regardless of any quantity chosen before the picker hid the
            // quantity selector.
            items = [
              giftBoxItem,
              { id: primaryVariantId, quantity: 1, properties: mainProperties },
              ...companionItems,
            ];
          }

          if (this.cart) this.cart.setActiveElement(document.activeElement);

          const giftFormData = new FormData(this.form);
          giftFormData.delete('id');
          giftFormData.delete('quantity');

          items.forEach((item, i) => {
            giftFormData.append(`items[${i}][id]`, item.id);
            giftFormData.append(`items[${i}][quantity]`, item.quantity);
            if (item.properties) {
              Object.entries(item.properties).forEach(([key, val]) => {
                giftFormData.append(`items[${i}][properties][${key}]`, val);
              });
            }
          });

          if (this.cart) {
            giftFormData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            giftFormData.append('sections_url', window.location.pathname);
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = giftFormData;

          fetchPromise = fetch(`${routes.cart_add_url}`, config);
        } else {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetchPromise = fetch(`${routes.cart_add_url}`, config);
        }

        fetchPromise
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
